import React, { PureComponent, Fragment } from 'react';
import classNames from 'classnames';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Picture, Video } from 'formlabs-web-components/Media';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import TextPlugin from '../../../../common/components/cms/TextPlugin';

import './FuseIntro.module.css';

const FuseIntro = DisplayComponent(
  class FuseIntro extends PureComponent {
    state = {
      mobile: false,
      scrollLock: false,
      scrollLockBottom: false,
      fadeIn: [false, false, false, false]
    };

    componentDidMount() {
      window.addEventListener('resize', this.debouncedResize);
      window.addEventListener('scroll', this.throttledScroll);
      window.addEventListener('resize', this.calcVidDims);
      this.resize();
      !this.state.mobile && this.calcVidDims();
      const xRayVideo = document.querySelector('.wc-slide-2 video');
      //iOS will not load the video until it has started to play. the two following lines make sure the bottom video plays for a second to let us manipulate .currentTime
      if (xRayVideo) {
        xRayVideo.play();
        xRayVideo.pause();
      }
    }
    componentWillUnmount() {
      window.removeEventListener('resize', this.debouncedResize);
      window.removeEventListener('scroll', this.throttledScroll);
      window.removeEventListener('resize', this.calcVidDims);
    }

    calcVidDims = () => {
      const length = 5;
      const video = {};
      video.el = document.querySelector('.wc-video--1 video');
      video.parent = video.el.parentElement;
      video.height = Math.min(
        video.el.clientWidth * 0.5625,
        window.innerHeight
      );
      video.length = video.height * length;
      video.end = video.top - video.height + video.length;
      this.setState({ video });
    };

    resize = () => {
      this.setState({ mobile: window.innerWidth <= 1050 });
    };
    scrollState = () => {
      const { mobile, position } = this.state;
      if (!mobile) {
        const topVideo = document.querySelector('.wc-slide-1').offsetHeight;
        const xRayVideo = document.querySelector('.wc-slide-2 video');
        const xRayVideoContainer = document.querySelector('.wc-slide-2');
        const proportion = window.innerWidth * 0.59;
        const bottomScroll = xRayVideoContainer.getBoundingClientRect();
        this.setState({ position: window.scrollY });
        this.setState({
          scrollLock:
            xRayVideo.getBoundingClientRect().top <= 0 &&
            window.scrollY >= 400 &&
            bottomScroll.bottom >= proportion,
          scrollLockBottom: bottomScroll.bottom <= proportion,
          fadeIn: [
            position >= 20,
            position >=
              topVideo * 0.3 + xRayVideoContainer.offsetHeight * 0.2 &&
              position <=
                topVideo * 0.3 + xRayVideoContainer.offsetHeight * 0.6,
            position >= topVideo * 0.3 + xRayVideoContainer.offsetHeight * 0.5,
            position >= topVideo * 0.3 + xRayVideoContainer.offsetHeight * 0.75
          ]
        });
        const frame =
          (position >= 0 ? position : 0) *
          (xRayVideo.duration / xRayVideoContainer.offsetHeight);
        xRayVideo.currentTime = isFinite(frame) ? frame : 0;
      }
    };

    debouncedResize = debounce(this.resize, 100);
    throttledScroll = throttle(this.scrollState, 100);

    render() {
      const {
        body,
        topVideo,
        topVideoPoster,
        xrayVideo,
        xrayVideoPoster,
        topMobileImage,
        xrayMobileImage,
        scrollText1,
        scrollText2,
        scrollText3,
        scrollText4,
        classes,
        styleNames,
        styles,
        children
      } = this.props;

      const {
        mobile,
        scrollLock,
        video,
        scrollLockBottom,
        fadeIn
      } = this.state;

      return (
        <div
          className={classes}
          styleName={classNames(styleNames)}
          style={styles}
        >
          <section className="wc-slide-1" styleName="section-header">
            <Grid direction="x" hasContainer={false}>
              <Cell smallSize={24} backgroundColor="black">
                <TextPlugin body={body}>{children}</TextPlugin>
              </Cell>
            </Grid>
            {mobile && (
              <Fragment>
                <Grid direction="x" hasContainer={true}>
                  <Picture largeImage={topMobileImage.src} />
                </Grid>

                <Grid
                  direction="x"
                  hasContainer={true}
                  primaryAlignment="align-center"
                >
                  <Cell smallSize={24} mediumSize={16}>
                    <p styleName="white-text">{scrollText1}</p>
                    <p styleName="white-text">{scrollText2}</p>
                  </Cell>
                </Grid>
                <div styleName="white-section">
                  <Grid direction="x" hasContainer={true}>
                    <Picture largeImage={xrayMobileImage.src} />
                  </Grid>
                  <Grid
                    direction="x"
                    hasContainer={true}
                    primaryAlignment="align-center"
                  >
                    <Cell smallSize={24} mediumSize={16}>
                      <p>{scrollText3}</p>
                      <p>{scrollText4}</p>
                    </Cell>
                  </Grid>
                </div>
              </Fragment>
            )}
            {!mobile && (
              <Fragment>
                <div
                  styleName="video--embed"
                  data-mobile="false"
                  className="wc-video"
                  data-poster={topVideoPoster.src}
                >
                  <Video
                    src={topVideo}
                    autoPlay={true}
                    loop={true}
                    poster={topVideoPoster.src}
                  />
                </div>
                <div
                  styleName={classNames('scroll-text-1', 'scroll-text', {
                    shown: fadeIn[0]
                  })}
                >
                  {scrollText1}
                </div>
              </Fragment>
            )}
          </section>

          {!mobile && (
            <section
              className="wc-slide-2"
              styleName="section-scroll"
              style={video ? { height: video.length } : {}}
            >
              <div
                styleName={classNames('video-container', {
                  locked: scrollLock,
                  'locked-bottom': scrollLockBottom
                })}
              >
                <div className="wc-video wc-video--1">
                  <Video
                    src={xrayVideo}
                    autoPlay={false}
                    loop={false}
                    poster={xrayVideoPoster.src}
                  />
                </div>
                <div className="">
                  <div
                    styleName={classNames('scroll-text-2', 'scroll-text', {
                      shown: fadeIn[1]
                    })}
                  >
                    {scrollText2}
                  </div>
                  <div
                    styleName={classNames('scroll-text-3', 'scroll-text', {
                      shown: fadeIn[2]
                    })}
                  >
                    {scrollText3}
                  </div>
                  <div
                    styleName={classNames('scroll-text-4', 'scroll-text', {
                      shown: fadeIn[3]
                    })}
                  >
                    {scrollText4}
                  </div>
                </div>
              </div>
            </section>
          )}
        </div>
      );
    }
  }
);

export default FuseIntro;
